module.exports = __webpack_public_path__ + "img/asianSmall.b7651c4c.jpg";